enum Status {
  PENDING = "PENDING",
  CLEARED = "CLEARED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  SPENT = "SPENT",
  SPENT_REFUND = "SPENT_REFUND",
  REFUND_SPENT = "REFUND_SPENT",
  EXPIRED = "EXPIRED",
  REWARD_WALLET_CLEARED = "REWARD_WALLET_CLEARED",
  REWARD_WALLET_SPENT = "REWARD_WALLET_SPENT",
  REWARD = "REWARD"
}

export default Status
